import React from 'react'

const ExamsContext = React.createContext({})
export const ExamsProvider = ExamsContext.Provider
export default ExamsContext